import { createAction } from 'redux-actions';
import { getChannelForWidget } from '@wix/wix-vod-shared/common';
import { getAllSettings } from '../../../selectors/app-settings';
import { canShowChannelCover } from '../../../components/player-overlay/selectors';
import { notForPreview } from '../../../utils/not-for-preview';
import {
  openFullScreenPurchaseOverlay,
  openFullScreenRentOverlay,
  openFullScreenSubscribeOverlay,
} from '../../../utils/open-overlay';
import { logPurchaseButtonClicked } from '../../../components/player-overlay/bi';
import { createProxy } from '../../../worker/lib';

import {
  getFullAccessActionName,
  FULL_ACCESS_ACTION_NAMES,
} from '@wix/wix-vod-shared/widget';

const OPEN_FULL_SCREEN_OVERLAY =
  'CLIENT.PLAYER_OVERLAY.OPEN_FULL_SCREEN_OVERLAY';
const openOverlayAction = createAction(OPEN_FULL_SCREEN_OVERLAY);

const openOverlay =
  (panoramaClient, { channelData, videoItem }, actionName) =>
  (dispatch) => {
    switch (actionName) {
      case FULL_ACCESS_ACTION_NAMES.SUBSCRIBE:
        return dispatch(
          openFullScreenSubscribeOverlay(panoramaClient, channelData.id),
        );
      case FULL_ACCESS_ACTION_NAMES.RENT:
        return dispatch(
          openFullScreenRentOverlay(
            panoramaClient,
            channelData.id,
            videoItem.id,
          ),
        );
      default:
        return dispatch(
          openFullScreenPurchaseOverlay(
            panoramaClient,
            channelData.id,
            videoItem.id,
          ),
        );
    }
  };

export const openPlayerOverlay = createProxy(
  'openPlayerOverlay',
  (panoramaClient, videoItem, showChannelCover) => (dispatch, getState) => {
    const state = getState();
    const channelData = getChannelForWidget(state);
    const appSettings = getAllSettings(state);
    const isChannelCover = canShowChannelCover(state, { showChannelCover });
    const actionName = getFullAccessActionName(channelData, videoItem);
    const props = {
      channelData,
      appSettings,
      videoItem,
      isChannelCover,
    };

    notForPreview(() => {
      dispatch(logPurchaseButtonClicked(props));
      dispatch(openOverlay(panoramaClient, props, actionName));
    })();

    dispatch(openOverlayAction());
  },
);
